import React, { useState, useEffect } from 'react';
import Loader from 'react-loaders';
import "./index.scss";
import AnimatedLetters from '../AnimatedLetters/index';
import mobileAppsData from '../../data/mobileApps.json';
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";



const MobileApps = () => {
    const [letterClass, setLetterClass] = useState('text-animate');
    const [activeIndex, setActiveIndex] = useState(0);
    const [isSlideshowOpen, setIsSlideshowOpen] = useState(false);
    const [slideshowImages, setSlideshowImages] = useState([]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLetterClass('text-animate-hover');
        }, 3000);

        return () => {
            clearTimeout(timer);
        }
    });

    const openSlideshow = (images) => {
        setSlideshowImages(images);
        setIsSlideshowOpen(true);
    }

    const closeSlideshow = () => {
        setIsSlideshowOpen(false);
        setSlideshowImages([]);
    }

    const handleSlideChange = ({ item }) => {
        setActiveIndex(item);
    }

    const renderMobileApps = (mobileApps) => {
        return (
            <>
            <div>
            {isSlideshowOpen && (
                <div className='slideshow-overlay'>
                    <div className='slideshow-content'>
                    <button onClick={closeSlideshow} className='close-button'>Close Slideshow</button>
                        <div className='slideshow-container'>
                            <AliceCarousel
                                autoPlay
                                autoPlayInterval={1500}
                                activeIndex={activeIndex}
                                items={slideshowImages.map((image, idx) => (
                                    <img key={idx} src={image} alt={`Slide ${idx}`} style={{borderRadius: 50}}/>
                                ))}
                                onSlideChanged={handleSlideChange}
                                />
                        </div>
                    </div>
                </div>
            )}
            </div>

            <div className="mobile-images-container">
                {
                    mobileApps.map((port, idx) => {
                        return (
                            <div className="image-box mobile-image-box" key={idx}>
                                <img 
                                className="portfolio-image"
                                src={port.cover} 
                                alt={port.alt}
                                />
                                <div className="content">
                                    <h4 className="title">{port.title}</h4>
                                    <p className="description">{port.description}</p>
                                    <button className="button" onClick={() => openSlideshow(port.screenshots)}>View</button>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            </>
        )
    }


    return (
        <>
        <div className="container portfolio-page">
            <h1 className="page-title">
                <AnimatedLetters 
                    letterClass={letterClass}
                    strArray={"Mobile Apps".split("")}
                    idx={15}
                />   
            </h1>
            <div>{renderMobileApps(mobileAppsData.mobileApps)}</div>
        </div>
        <Loader type="ball-clip-rotate-multiple" />
        </>
    )
}

export default MobileApps;